import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonEditLink from 'components/atoms/Editors/EditorMenuButtonEditLink/EditorMenuButtonEditLink.styles';

const EditorMenuButtonEditLink = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonEditLink');

  return <StyledEditorMenuButtonEditLink buttonRef={ref} {...innerProps} />
});

EditorMenuButtonEditLink.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonEditLink;
